export default __webpack_public_path__ + "static/media/saint-malomini.9c1f331a.jpg";